import { createAction, props } from "@ngrx/store";

export const loadDashboardData = createAction(
  "[DashboardData] Load Dashboard Data",
  props<{ projectId: any }>()
);

export const loadDashboardDataSuccess = createAction(
  "[DashboardData] Load Dashboard Data Success",
  props<{ dashboardData: any }>()
);

export const loadDashboardDataFailure = createAction(
  "[DashboardData] Load Dashboard Data Failure",
  props<{ error: any }>()
);

// Actions for Allocated Projects
export const loadAllocatedProjects = createAction(
  "[Dashboard] Load Allocated Projects"
);

export const loadAllocatedProjectsSuccess = createAction(
  "[Dashboard] Load Allocated Projects Success",
  props<{ allocatedProjects: any }>()
);

export const loadAllocatedProjectsFailure = createAction(
  "[Dashboard] Load Allocated Projects Failure",
  props<{ error: any }>()
);

// Actions for Selcted Project
export const setSelectedProject = createAction(
  "[Dashboard] Set Selected Project", props<{ selectedProject: any }>()
);

export const setSelectedProjectSuccess = createAction(
  "[Dashboard] Set Selected Project Success",
  props<{ selectedProject: any }>()
);

export const setSelectedProjectFailure = createAction(
  "[Dashboard] Set Selected Project Failure",
  props<{ error: any }>()
);

export const logout = createAction('[Auth] Logout');